function fetchConfig(type = "json") {
  var contentType = "application/" + type;

  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: contentType,
    },
  };
}
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }
      isNumeric(num) {
        return /^-?[0-9]+(?:\.[0-9]+)?$/.test(num + "");
      }
      formDataToFormData(obj, form, namespace) {
        var fd = form || new FormData();
        var formKey;
        obj.forEach((value, key) => {
          if (namespace) {
            formKey = namespace + "[" + key + "]";
          } else {
            formKey = property;
          }
          if (typeof value === "object" && !(value instanceof File)) {
            objectToFormData(value, fd, property);
          } else {
            // if it's a string or a File object
            fd.append(formKey, value);
          }
        });
      }
      onSubmitHandlerGiftBox(quanlity, key) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        document.getElementById("gift-box-quantity").value = quanlity;
        const formData = new FormData(document.getElementById("form-gift-box"));
        formData.append(`[properties][_parentKey]`, key);
        config.body = formData;
        return fetch(`${routes.cart_add_url}`, config).then((response) =>
          response.json()
        );
      }
      onSubmitHandlerGiftCard(quanlity, key) {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        document.getElementById("gift-card-quantity").value = quanlity;
        const formData = new FormData(
          document.getElementById("form-gift-card")
        );
        formData.append(`[properties][_parentKey]`, key);
        config.body = formData;
        return fetch(`${routes.cart_add_url}`, config).then((response) =>
          response.json()
        );
      }
      getAddonVariant(mainform) {
        const formData = new FormData();
        const key = new Date().getTime().toString();
        // Loop through the object
        document.getElementById("gift-box-quantity").value =
          document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;

        const formAddonData = new FormData(
          document.getElementById("form-gift-box")
        );

        mainform.append(`[properties][_itemKey]`, key);
        this.formDataToFormData(mainform, formData, "items[0]");
        formAddonData.append(`[properties][_parentKey]`, key);
        this.formDataToFormData(formAddonData, formData, "items[1]");

        return formData;
      }
      convertFormToJSON(elem) {
        let output = {};
        new FormData(elem).forEach((value, key) => {
          // Check if property already exist
          if (Object.prototype.hasOwnProperty.call(output, key)) {
            let current = output[key];
            if (!Array.isArray(current)) {
              // If it's not an array, convert it to an array.
              current = output[key] = [current];
            }
            current.push(value); // Add the new value to the array.
          } else {
            output[key] = value;
          }
        });
        return output;
      }
      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (
          this.submitButton &&
          this.submitButton.getAttribute("aria-disabled") === "true"
        )
          return;

        this.handleErrorMessage();
        if (this.submitButton) {
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
        }

        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const linesUpdateDeferred = this.dispatchCartLinesUpdateEvent(formData);

        let key = new Date().getTime().toString();
        formData.append(`[properties][_itemKey]`, key);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        var inputBuyGift = document.getElementById("choose-to-buy");
        const pack = document.querySelector(".form-pack")
        if (pack) {
          formData.append(`[properties][isNotChangeQty]`, true);
        }
        config.body = formData;

        if (inputBuyGift && inputBuyGift.checked) {
          //config.body = this.getAddonVariant(formData);
          const rectGift = inputBuyGift.getBoundingClientRect();
          const isVisible =
            rectGift.bottom > 0 && rectGift.top < window.innerHeight;
          let quantity = document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;

          const qtyBox = document.querySelector("input[name='quantity-box']")
          if (qtyBox) {
            quantity = qtyBox.value || 1;
            key = undefined;
          }

          if (isVisible) {
            await this.onSubmitHandlerGiftBox(quantity, key);
          }
        }

        var inputBuyGiftCard = document.getElementById("choose-to-buy-card");
        if (inputBuyGiftCard && inputBuyGiftCard.checked) {
          //config.body = this.getAddonVariant(formData);
          const rectGift = inputBuyGiftCard.getBoundingClientRect();
          const isVisible =
            rectGift.bottom > 0 && rectGift.top < window.innerHeight;
          const quantity = document.querySelector(
            "product-form.product-form form input[name='quantity']"
          ).value;
          if (isVisible) {
            await this.onSubmitHandlerGiftCard(quantity, key);
          }
        }

        const activePack = document.querySelector('.pack-selector.active');

        if (activePack) {
          const formObj = {};
          const properties = {};

          // 1) Chuyển FormData -> object, đồng thời gom properties[...] vào `properties`
          formData.forEach((value, key) => {
            const m = key.match(/^properties\[(.+)\]$/);
            if (m) {
              properties[m[1]] = value;
            } else {
              formObj[key] = value;
            }
          });

          formObj.properties = properties;

          const variantIds = Array.from(
            activePack.querySelectorAll('.pack-3-hidden-inputs input[name^="pack_"][name$="_variant_id"]')
          )
            .map(input => input.value)
            .filter(Boolean);

          if (variantIds.length === 0) {
           // this.handleErrorMessage("Không tìm thấy sản phẩm trong pack.");
          }

        
          const items = variantIds.map(variantId => {
            const item = Object.assign({}, formObj);

            item.id = Number(variantId);
            item.quantity = Number(formObj.quantity) || 1;

            return item;
          });

          config.method = "POST";
          config.headers["Content-Type"] = "application/json";
          config.body = JSON.stringify({ items });
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              linesUpdateDeferred?.reject(new Error(response.description));
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              // alert("test addtocart", response, e);
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              const { CartLinesUpdateEvent } = window.StandardEvents || {};
              if (CartLinesUpdateEvent) {
                const cartDataPromise = this.cart?.tagName === 'CART-DRAWER'
                  ? Promise.resolve(response)
                  : CartItems.fetchCartData();

                cartDataPromise.then((cartData) => {
                  if (cartData) {
                    linesUpdateDeferred?.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cartData) });
                  } else {
                    linesUpdateDeferred?.resolve();
                  }
                });
              }

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            linesUpdateDeferred?.reject(e);
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
          });
      }

      dispatchCartLinesUpdateEvent(formData) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();

        // Check if there is an active pack
        const activePack = this.querySelector('.pack-selector.active');
        let lines = [];
        if (activePack) {
          const variantIds = Array.from(
            activePack.querySelectorAll('.pack-3-hidden-inputs input[name^="pack_"][name$="_variant_id"]')
          )
            .map(input => input.value)
            .filter(Boolean);
          const quantity = Number(formData.get('quantity') || 1);
          lines = variantIds.map(variantId => ({ id: variantId, quantity }));
        } else {
          lines.push({ id: formData.get('id'), quantity: Number(formData.get('quantity') || 1) });
        }

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: this.closest('dialog') || this.closest('cart-drawer') ? 'dialog' : 'product',
            lines,
            promise: deferred.promise,
          })
        );

        return deferred;
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );
        if (typeof this.errorMessageWrapper.toggleAttribute == "function") {
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        }

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


function getCookieGlobal(key) {
  var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? keyValue[2] : null;
}

const classClosePhoto = [
  ".closed-photo-image",
  ".upload_image_guidelines",
  ".closed-bg-photo",
];
classClosePhoto.forEach(function (nameClass) {
  var element = document.querySelector(nameClass);
  if (element) {
    element.addEventListener("click", function () {
      document.querySelector(".modal-custom-image").classList.toggle("hidden");
      document.querySelector(".closed-bg-photo").classList.toggle("hidden");
    });
  }
});

const classPhotoGift = [
  ".photo-gift",
  ".closed-photo-gift",
  ".closed-bg-photo-gift",
];
classPhotoGift.forEach(function (nameClass) {
  var element = document.querySelector(nameClass);
  if (element) {
    element.addEventListener("click", function () {
      document.querySelector(".modal-photo-gift").classList.toggle("hidden");
      document
        .querySelector(".closed-bg-photo-gift")
        .classList.toggle("hidden");
    });
  }
});


/* end page product */
document.addEventListener('click', function(e) {
    const isToggle = e.target.closest('.box-shipping-time, .express-shipping-pills');
    const isCloseBtn = e.target.closest('.js-close-shipping-modal');
    const isInsideModal = e.target.closest('.shipping-modal-inner');
    
    if (!isToggle && !isCloseBtn && isInsideModal) return; 

    const grids = document.querySelectorAll('.new-shipping ~ .modal-shipping .wt-grid');
    if (grids.length === 0) return;
    const needsClose = isCloseBtn || (!isInsideModal && !isToggle);

    grids.forEach(grid => {
      if (isToggle) {
        const isClosed = grid.classList.contains('box-hover-shipping');
        if (isClosed) {
          grid.classList.remove('box-hover-shipping');
          document.body.style.overflow = 'hidden';
          
          setTimeout(() => {
            grid.querySelectorAll('.pill-toggle-group').forEach(group => {
              const activeBtn = group.querySelector('.pill-btn.active');
              const slider = group.querySelector('.pill-slider');
              if (activeBtn && slider) {
                slider.style.width = `${activeBtn.offsetWidth}px`;
                slider.style.transform = `translateX(${activeBtn.offsetLeft - 4}px)`;
              }
            });
          }, 50);
        } else {
          grid.classList.add('box-hover-shipping');
          document.body.style.overflow = '';
        }
      } else if (needsClose) {
        grid.classList.add('box-hover-shipping');
        document.body.style.overflow = '';
      }
    });
});

const mediaModal = document.querySelector(".product-media-modal");
if (mediaModal) {
  mediaModal.addEventListener("click", function (event) {
    const element = event.target;
    const children = document.querySelector(
      ".product-media-modal__content.color-background-1.gradient"
    );

    const isOpen = document.querySelector(".product-media-modal[open]");

    if (isOpen) {
      if (children && !children.contains(element)) {
        const toggleBtn = document.querySelector(".product-media-modal__toggle");
        if (toggleBtn) toggleBtn.click();
      }
    }
  });
}


// default qty buy pack 
document.addEventListener("DOMContentLoaded", function () {
  const pack = document.querySelector('.qty_default_box');
  const qty_box = document.querySelector('input[name="quantity-box"]');

  if (pack && qty_box) {
    const count = parseInt(pack.textContent, 10) || 1;
    qty_box.value = count;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  // Product page: mobile preview button visibility logic
  const mbPreviewBtn = document.querySelector('.btn-preview.hidden-xl');
  const mainPreviewBtn = document.querySelector('#btn-preview-desktop');

  if (mbPreviewBtn && mainPreviewBtn) {
    const previewObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            mbPreviewBtn.classList.add('hidden-btn-preview');
          } else {
            mbPreviewBtn.classList.remove('hidden-btn-preview');
          }
        });
      },
      {
        threshold: 0,
      }
    );

    previewObserver.observe(mainPreviewBtn);
  }
})
